import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import { CardImageRoot as Root } from "./styled";
import { cardImagePropTypes } from "./propTypes";
export default function CardImage(props) {
  return ___EmotionJSX(Root, props);
}
CardImage.displayName = 'CardImage';
CardImage.propTypes = process.env.NODE_ENV !== "production" ? cardImagePropTypes : {};